export const endpoint = "https://qbmedia.b-cdn.net/qbmedia/"

export const bizDetails = {
    name: "بيــت المتــدرب",
    description: "جميع أنواع المكملات الغذائيه",
    socialBtns : {
        call: "اتصل",
        wsp: "واتساب",
        ig: "انستاغرام",
        fb: "فيسبوك",
        website: "الموقع",
        tiktok:"تيكتوك",
        menu:"كاتالوج",
        waze:"وييز",
        mail: "أميل",
        review: "قييمني",
        meeting: "عين موعد"
    },
    saveBtnText: "ضيفني لجهات الاتصال",
    orderNowText: "أطلب منتجك الأن"
}

export const bizDetails_He = {
    name: "בית המתאמן",
    description: "הכתובת שלכם לכל תוספי התזונה",
    socialBtns : {
        call: "שיחה",
        wsp: "וואטספ",
        ig: "אינסטגרם",
        fb: "פייסבוק",
        website: "האתר",
        tiktok:"טיקטוק",
        menu:"קטלוג",
        waze:"וואיז",
        mail: "מייל",
        review: "דרג אותנו",
        meeting: "פגישה"
    },
    saveBtnText: "הוסף אותנו לאנשי קשר",
    orderNowText: "הזמן שירות עכשיו"
}

export const bizDetails_En = {
    name: "Bethamtamen",
    description: "Your best detination for gym supplies",
    socialBtns : {
        call: "Call Us",
        wsp: "WSP",
        ig: "IG",
        fb: "FB",
        website: "Website",
        tiktok:"Tiktok",
        menu:"catalog",
        waze:"Waze",
        mail: "Mail",
        review: "Rate Us",
        meeting: "Meet Us"
    },
    saveBtnText: "Add Us To Contacts",
    orderNowText: "Order a Service"
}

export const contact = {
    name: "Mohammad Oraby",
    phone: "972548357277",
    email: "MohammadOraby@gmail.com",
    website: "https://bhm.qbmedia.co.il/",
    ig:"bethamtamen",
    fb:"p/בית-המתאמן-get-healthy-100063638705229/",
    tiktok:"@bethamtamen",
    menu:"https://bhm-catalog.qbmedia.co.il/",
    waze: "waze.com",
};

export const schedule = {
    link:"https://.com",
    title:"קביעת פגישה אונליין",
}

export const footer = {
    desclaimer: "برمجه وتصميم",
    copywrites: "كيوبي ميديا"
}

export const socialAccounts = {
    wsp:`https://api.whatsapp.com/send?phone=${contact.phone}`,
    ig:`http://instagram.com/${contact.ig}`,
    fb:`https://facebook.com/${contact.fb}`,
    tiktok:`https://www.tiktok.com/${contact.tiktok}`,
}